export default __webpack_public_path__ + "static/media/first.de560c08.mp4";